/*发票审批 */
import { $http, buildHeaders } from "./index";

//获取列表
export const meetinginvoice_page = (params) => {
  return $http.get("/admin/MeetingInvoiceApprove/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取待审批详情
export const meetinginvoice_detail = (id) => {
  return $http.get(
    "/admin/MeetingInvoiceApprove/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取已审批详情
export const meetinginvoice_search = (id) => {
  return $http.get(
    "/admin/MeetingInvoiceApprove/detail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//审批
export const meetinginvoice_approve = (data) => {
  return $http.post("/admin/MeetingInvoiceApprove/approve", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//确认付款
export const meetingpurchasepaymentapply_pay = (data) => {
  return $http.post("/admin/MeetingPurchasePaymentApply/pay", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};
